import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiserviceService } from '../apiservice.service';





@Component({
  selector: 'app-tvshow',
  templateUrl: './tvshow.component.html',
  styleUrls: ['./tvshow.component.scss']
})

export class TvshowComponent implements OnInit, OnDestroy {



  
  movies:any[]=[];
  imgPrefix:string="https://image.tmdb.org/t/p/w500";
  pageNumber:any;
  channel:any;


  constructor(private _ApiserviceService:ApiserviceService,private _ActivatedRoute:ActivatedRoute ) {


    this.channel=this.pageNumber=this._ActivatedRoute.snapshot.paramMap.get("pageNumber")
 
   
    this._ApiserviceService.getTvShow(this.pageNumber).subscribe( (data)=>{

      
      this.movies=data.results
      




   })


  }
  
  ngOnInit(): void {
  }



  search($event:any){
 
    this._ApiserviceService.searchTv($event.target.value).subscribe((data)=>{
      this.movies=data.results
    
    })
  }

  test($event:any){
   this.pageNumber=$event.target.innerHTML
   this._ApiserviceService.getMovies(this.pageNumber).subscribe( (data)=>{ this.movies=data.results })
   window.scroll({ top: 100,    left: 100,  behavior: 'smooth'   });

   
   
 }
 
  ngOnDestroy(){
    
    
    
        
      }

}
